import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import firebase from "firebase/app";
import styled from "styled-components";
import moment from "moment";
import Row from "./Row";

const TideContainer = styled.div`
  padding: 0.5rem 10px 1rem;
  font-size: 0.9rem;
  border-top: 1px solid #eeeeee;
`;
const Title = styled.div`
  text-align: center;
  font-size: 2rem;
  text-transform: capitalize;
  padding: 2rem 10px 0.5rem;
`;

const Footer = styled.div`
  padding: 0.5rem 10px 1rem;
  font-size: 10px;
`;
const TideTable = (props) => {
  const { spotName } = props;
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(undefined);
  const [tides, setTides] = useState(undefined);
  const [dateNow, setDateNow] = useState(undefined);

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("tides")
      .doc(spotName)
      .onSnapshot(
        (doc) => {
          setLoading(false);
          setTides(doc.data().tideData);
          setDateNow(doc.data().dateNow);
        },
        (err) => {
          setError(err);
        }
      );
    // returning the unsubscribe function will ensure that
    // we unsubscribe from document changes when our id
    // changes to a different value.
    return () => unsubscribe();
  }, [spotName]);

  const currentTime = Number(
    moment().hour() + moment().minute().toString().padStart(2, "0")
  );

  const message = (currentTime, closestTideRow) => {
    const closestTideTime = Number(closestTideRow[0].time.replace(":", ""));
    const nextTideWithDate = `${moment().format("YYYY-MM-DD")} ${
      closestTideRow[0].time
    }`;
    let message = `${moment(nextTideWithDate).fromNow()}.`;
    if (closestTideTime < currentTime) {
      message = `${moment(nextTideWithDate).fromNow()}.`;
    }

    return message;
  };

  const tideTable = (tides) => {
    const tideTimes = tides.map((tide) => Number(tide.time.replace(":", "")));
    const sortedArray = tideTimes.sort(
      (a, b) => Math.abs(a - currentTime) - Math.abs(b - currentTime)
    );
    const closestTideRow = tides.filter(
      (tide) => Number(tide.time.replace(":", "")) === sortedArray[0]
    );

    const table = tides.map((tide) => {
      const tideLabel = tide.label === "LT" ? "Low tide" : "High tide";
      return (
        <Row key={tide.time} closest={closestTideRow[0].time === tide.time}>
          <span style={{ flexBasis: "80px" }}>{tideLabel}</span>
          <span
            style={{ flexBasis: "80px", textAlign: "right", paddingRight: 20 }}
          >
            {tide.height}m
          </span>
          <span style={{ flexBasis: "44px" }}>{tide.time}</span>
          {closestTideRow[0].time === tide.time && (
            <span>{message(currentTime, closestTideRow)}</span>
          )}
        </Row>
      );
    });
    return table;
  };

  return (
    <>
      <Title>Tide times</Title>

      {loading && "loading tides"}
      {!loading && error && error}
      {!loading && tides && <TideContainer>{tideTable(tides)}</TideContainer>}
      {!loading && tides && tides[0] && (
        <Footer>Tides in GMT, last updated {dateNow}</Footer>
      )}
    </>
  );
};

TideTable.propTypes = {
  children: PropTypes.node,
};

TideTable.defaultProps = {
  children: undefined,
};

export default TideTable;
